export default __webpack_public_path__ + "static/media/zstore-logo.8b1a2edd.svg";